// eslint-disable-next-line import/no-anonymous-default-export
export default { 
    colors: {
        brand1: {
            pure: '#DBC7B8',
            light: ' #F5EFEA',
            medium: '#CAAC96',
            dark: '#845F43',
        },
        brand2: {
            pure: '#8D81D7',
            light: '#AAA2DE',
            medium: '#65259E',
            dark: '#400D50',
        },
        brand4: {
            pure: '#363435',
            light: ' #E7EFED',
            medium: '#424242',
            dark: '#212121',
        },
        typography1: {
            pure: '#FFFFFF',
            light: '#EDEDED',
            medium: '#EEEEEE',
            dark: '#BDBDBD',
        },
        typography2: {
            pure: '#000000',
            light: '#757575',
            medium: '#616161',
            dark: ' #424242',
        },
        typography3: {
            pure: '#212121',
            light: '#E0E0E0',
            medium: '#9E9E9E',
            dark: '#424242',
        },
        neutral1: {
            pure: '#FFFFFF',
            light: '#FAFAFA',
            medium: '#EEEEEE',
            dark: '#BDBDBD',
        },
        neutral2: {
            pure: '#000000',
            light: '#757575',
            medium: '#616161',
            dark: '#424242'
        },
        error: {
            pure: '#D66157',
            light: '#F4D5D2',
            medium: '#A03127',
            dark: '#4E1813'
        },
        success: {
            pure: '#148A6A',
            light: '#E1F8F1',
            medium: '#54BFA2',
            dark: '#00684C'
        },
        warning: {
            pure: '#E3CC6C',
            light: '#FFFAE8',
            medium: '#E3BE25',
            dark: '#978126'
        },
        backLink: {
            pure: '#0A598C',
            light: '#C5E4F8',
            medium: '#2696DE',
            dark: '#094064'
        }
    }
}